{
	"translateAcquirerTansactionType": {
		"credit": "Crédit",
		"debit": "Débit"
	}
}
